import { Component, Inject } from '@angular/core';

import get from 'lodash/get';

import { ISitemap, SITEMAP } from 'pbc.angular';
import { ISorterConfig } from 'pbc.types';

import { DurchgangQuerySorterConfig } from 'fa-kt.types';
import { DurchgangService } from '../service';

@Component({
  selector: 'fa-kt-durchgang-sorter',
  templateUrl: './durchgang-sorter.component.html',
  styleUrls: ['./durchgang-sorter.component.css'],
})
export class DurchgangSorterComponent {
  public DurchgangSorterConfig: ISorterConfig;

  constructor(
    @Inject(SITEMAP) private sitemap: ISitemap,
    public durchgang: DurchgangService,
  ) {
    this.DurchgangSorterConfig = DurchgangQuerySorterConfig.map((filter) => ({ ...filter, title: get(sitemap, filter.title, filter.title) as string }));
    /* << update    */
    /*    update >> */
  }
}
